let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8aUUY")).then(() => parcelRequire('4kIKR'));